import * as React from "react";
import {
  Checkbox,
  FormControlLabel,
  FormHelperText,
  FormControl,
} from "@mui/material";
import { FieldLabelWithHelp } from "./FieldHelpIcon";

type InputBooleanProps = {
  label: string;
  value: boolean;
  helperText?: string;
  error?: boolean;
  onChange: (value: boolean) => void;
  autoFocus?: boolean;
  disabled?: boolean;
  hidden?: boolean;
  description?: string;
};

export const InputBoolean: React.FC<InputBooleanProps> = ({
  label,
  value,
  onChange,
  helperText = "",
  error = false,
  autoFocus = false,
  disabled = false,
  hidden = false,
  description,
}) => {
  if (hidden) return null;
  return (
    <FormControl>
      <FormControlLabel
        sx={{ ml: 1 }}
        control={
          <Checkbox
            disabled={disabled}
            autoFocus={autoFocus}
            size={"small"}
            checked={value}
            onChange={(_event, checked) => onChange(checked)}
          />
        }
        label={<FieldLabelWithHelp label={label} description={description} />}
      />
      <FormHelperText error={error}>{helperText}</FormHelperText>
    </FormControl>
  );
};
